import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { isAuthenticated, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div
        data-testid="auth-loading"
        className="min-h-screen flex items-center justify-center bg-[#FAFBFF]"
      >
        <div className="flex flex-col items-center gap-3">
          <div className="h-8 w-8 rounded-full border-2 border-[#E8EAF3] border-t-[#011B90] animate-spin" />
          <span className="text-[12px] tracking-wide text-[#9098A8] font-medium">
            Loading your workspace…
          </span>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    const next = location.pathname + location.search;
    const q = next && next !== "/" ? `?next=${encodeURIComponent(next)}` : "";
    return <Navigate to={`/login${q}`} replace />;
  }

  return children;
}
